export default "__VITE_ASSET__BJmUbyy3__"